import { memo, useMemo } from "react"
import { Box } from "@chakra-ui/react"
import { useImage } from "@app/hooks/useImage"
import { useRoutes } from "@app/hooks/useRoutes"
import { ImageTextItem } from "./ImageTextItem"
import { ImageTextItemIconText } from "./ImageTextItemIconText"

const ImageText: React.FC<GatsbyTypes.SanitySectionImageText> = ({ items: rawItems }) => {
  const { getResponsiveImage } = useImage()
  const { urlResolver } = useRoutes()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const items = useMemo(
    () =>
      rawItems?.map(({ image, ...item }: any) => ({
        ...item,
        image: Array.isArray(image) ? image?.map((image: any) => getResponsiveImage(image)) : image,
        key: item?._key,
        link: urlResolver(item?.link),
      })),
    [getResponsiveImage, rawItems, urlResolver]
  )

  return (
    <Box as="section">
      {items?.map(item => {
        if (item?._type === "objectSectionIconText") {
          return <ImageTextItemIconText key={item?._key} item={item} />
        }
        return <ImageTextItem key={item?.key} item={item} />
      })}
    </Box>
  )
}

export default memo(ImageText)
